<mat-card class="isla mat-elevation-z6">
  <div class="isla-accent" [style.background]="colorEstado()"></div>

  <div class="isla-head">
    <span class="isla-dot" [style.background]="colorEstado()"></span>
    <div class="isla-headtext">
      <span class="isla-title">{{ (sirena?.tipo | titlecase) || "Sirena" }}</span>
      <span class="isla-sub">{{ sirena?.chipId }}</span>
    </div>
    <span class="grow"></span>
    <button mat-icon-button (click)="cerrar()" aria-label="Cerrar">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="isla-body">
    @if (sirena?.estado) {
      <div class="isla-row">
        <span class="k">Estado</span>
        <span class="estado-pill" [style.color]="colorEstado()">
          <span class="d" [style.background]="colorEstado()"></span>
          {{ sirena?.estado }}
        </span>
      </div>
    }
    @if (sirena?.versionFirmware) {
      <div class="isla-row">
        <span class="k">Firmware</span>
        <span class="v">{{ sirena?.versionFirmware }}</span>
      </div>
    }
    @if (sirena?.rssi) {
      <div class="isla-row">
        <span class="k">Señal</span>
        <span class="v">{{ helper.rssiToText(sirena?.rssi).label }}</span>
      </div>
    }
    <div class="isla-row">
      <span class="k">Chip ID</span>
      <a class="v link" [routerLink]="['/', 'main', 'sirenas', sirena?._id]">
        {{ sirena?.chipId }}
      </a>
    </div>
  </div>
</mat-card>
